import styles from './WalletTabs.module.css';

export const WalletTabs = ({ activeTab, setActiveTab, tabs }) => (
  <div className={styles.Tabs}>
    {tabs.map((tab, i) => (
      <button
        key={i}
        className={`${styles.Tab} ${activeTab === tab.type ? styles.TabActive : ''}`}
        onClick={() => setActiveTab(tab.type)}
        type="button">
        {tab.name}
      </button>
    ))}
  </div>
);
